export const FETCH_LEAGUES_START = "FETCH_LEAGUES_START";
export const FETCH_LEAGUES_SUCCESS = "FETCH_LEAGUES_SUCCESS";
export const FETCH_LEAGUES_FAILURE = "FETCH_LEAGUES_FAILURE";
export const FETCH_SELECTED_LEAGUE = "FETCH_SELECTED_LEAGUE";
export const FETCH_SELECTED_TEAM = "FETCH_SELECTED_TEAM";
export const FETCH_SELECTED_STADIUM = "FETCH_SELECTED_STADIUM";
export const CHECK_UPDATE_LEAGUES = "CHECK_UPDATE_LEAGUES";
